import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { removeHash } from 'react-scrollable-anchor';
import { withStyles, MuiThemeProvider } from '@material-ui/core/styles';
import withStores from '@studionand/ada-next/src/stores/withStores';
import adaTheme from '@studionand/ada-next/src/theme';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import cx from 'classnames';
import TableOfContentStore from './store.js';

const jssStyles = theme => ({
  container: {
    userSelect: 'none',
    position: 'relative',
  },
  floating: {
    position: 'absolute',
    zIndex: 10,
    top: theme.spacing(1),
    left: theme.spacing(1),
    transform: 'translate(0, 100%)',
  },
  label: {
    ...theme.typography.caption,
  },
});

@withStyles(jssStyles)
@withStores('pagesStore', 'appStore')
@observer
class TableOfContent extends Component {
  get hasTableOfContent() {
    const hasTableOfContent = this.props.pagesStore.currentPage.data
      .hasTableOfContent;
    if (typeof hasTableOfContent === 'string') {
      return hasTableOfContent === 'true';
    } else {
      return hasTableOfContent;
    }
  }

  handleMouseDown = (e, hash) => {
    // if the hash is already set remove it so it can be set again
    // triggering another scroll to the same location
    if (hash === window.location.hash) {
      removeHash();
    }
  };

  handleToggleShowToc = e => {
    const { pagesStore } = this.props;
    pagesStore.currentPage.updatePageData({
      hasTableOfContent: e.target.checked,
    });
  };

  renderUi = () => {
    const { classes } = this.props;
    return (
      <MuiThemeProvider theme={adaTheme}>
        <FormControlLabel
          classes={{
            label: classes.label,
            root: cx({ [classes.floating]: this.hasTableOfContent }),
          }}
          control={
            <Checkbox
              name="show-quick-nav"
              onChange={this.handleToggleShowToc}
              checked={this.hasTableOfContent}
            />
          }
          label="Sprungnavigation anzeigen"
        />
      </MuiThemeProvider>
    );
  };

  render() {
    const {
      page,
      blockTypes,
      item: Item,
      container: Container,
      // readOnly,
      isSticky,
      classes,
      appStore,
    } = this.props;
    const readOnly = !appStore.editMode;
    if (!page) return null;
    const { activeBlock } = TableOfContentStore;
    const activeKey =
      (activeBlock && activeBlock.offsetKey.replace('-0-0', '')) || null;
    const { blocks, data } = page;
    const items = blocks.filter(b => blockTypes.indexOf(b.type) !== -1);
    const hasItems = items.length > 0;
    // if (!hasItems) return null;
    if (readOnly && !hasItems) return null;
    return (
      <div contentEditable={false} className={classes.container}>
        {!readOnly && this.hasTableOfContent && this.renderUi()}
        <Container isSticky={isSticky}>
          {!readOnly && !this.hasTableOfContent && this.renderUi()}
          {this.hasTableOfContent &&
            hasItems &&
            items.map(m => (
              <Item
                isActive={m.key === activeKey}
                type={m.type}
                key={m.key}
                href={`#${m.key}`}
                onMouseDown={e => this.handleMouseDown(e, `#${m.key}`)}
              >
                {m.text.trim()}
              </Item>
            ))}
        </Container>
      </div>
    );
  }
}

TableOfContent.propTypes = {
  page: PropTypes.object.isRequired,
  blockTypes: PropTypes.array.isRequired,
  readOnly: PropTypes.bool.isRequired,
  isSticky: PropTypes.bool.isRequired,
  item: PropTypes.node.isRequired,
  container: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  pagesStore: PropTypes.object.isRequired,
};

TableOfContent.defaultProps = {
  page: null,
  blockTypes: ['header-one'],
  readOnly: true,
  item: null,
  container: null,
};

export default TableOfContent;
